import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-piano",
  "use": "icon-si-glyph-piano-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-piano\" id=\"icon-si-glyph-piano\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>920</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0,3 L0,12 L15.986,12 L15.986,3 L0,3 L0,3 Z M2,4 L4,4 L4,5 L2,5 L2,4 L2,4 Z M15.083,11.059 L0.992,11.059 L0.992,7 L2.083,7 L2.083,9.938 L2.992,9.938 L2.992,7 L4.083,7 L4.083,9.938 L4.992,9.938 L4.992,7 L6.083,7 L6.083,9.938 L6.992,9.938 L6.992,7 L9.083,7 L9.083,9.938 L9.992,9.938 L9.992,7 L11.083,7 L11.083,9.938 L11.992,9.938 L11.992,7 L13.083,7 L13.083,9.938 L13.992,9.938 L13.992,7 L15.083,7 L15.083,11.059 L15.083,11.059 Z M15,5 L8,5 L8,4 L15,4 L15,5 L15,5 Z\" fill=\"#555555\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-piano.svg
// module id = L1La
// module chunks = 62